/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { Plate } from "src/classes/plate/Plate";
import { PreviewWrapper } from "src/components/Shared/PageThumbnail/PageThumbnail";
import { CreatePage } from "src/components/UI/Icons";
import { Tooltip } from "src/components/UI/Tooltip";
import { DEFAULT_THUMBNAIL_WIDTH } from "src/lib/constants";

export function CreationThumbnail() {
  const handleClick = () => {
    Plate.create().then((plate) => plate?.open());
  };

  return (
    <PreviewWrapper>
      <Tooltip tooltipText="Create New Plate" delayShow={1000}>
        <StyledCreate onClick={handleClick}>
          <CreatePage />
        </StyledCreate>
      </Tooltip>
    </PreviewWrapper>
  );
}

const StyledCreate = styled.div`
  width: ${DEFAULT_THUMBNAIL_WIDTH};
  height: 205px; // manual
  position: relative;
  border: ${({ theme }) => `2px solid ${theme.primary}`};
  color: ${({ theme }) => `${theme.primary}`};
  overflow: hidden;
  transition-duration: 0.2s;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
  &:active {
    opacity: 0.3;
  }

  display: flex;
  flex-direction: column;
  cursor: pointer;
`;
